import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { TextAreaCustom } from './styles';

const TextArea = ({ row = '10', cols = '30', onChange, className, error, value, maxLength }) => {
  return (
    <div className={classNames(className)}>
      <TextAreaCustom
        rows={row}
        cols={cols}
        value={value}
        onChange={onChange}
        className={classNames({
          'form__form-group-field': true,
          'form__form-group-field--error': error,
        })}
        maxLength={maxLength}
      />
    </div>
  );
};

TextArea.defaultProps = {
  className: '',
  row: '',
  cols: '',
  error: false,
  value: undefined,
  maxLength: 500,
};

TextArea.propTypes = {
  row: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  cols: PropTypes.string,
  className: PropTypes.string,
  error: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
  maxLength: PropTypes.number,
};

export default TextArea;
